module.exports = __webpack_public_path__ + "static/media/icon.857f8bed.svg";